import LoanPending from './LoanPending';

export default LoanPending;
